import React from 'react'
import PropTypes from 'prop-types'

export default class ContentEditable extends React.Component {
  static propTypes = {
    textual: PropTypes.bool,
  }

  static defaultProps = {
    textual: true,
  }

  render() {
    const { tagName, html, textual, selectText, ...props } = this.props
    if (textual) {
      props.onPaste = this.onPaste
    }

    return React.createElement(tagName || 'div', {
      ...props,
      spellCheck: false,
      ref: e => (this.htmlEl = e),
      onInput: this.emitChange,
      onBlur: this.props.onBlur || this.emitChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      contentEditable: !this.props.disabled,
      dangerouslySetInnerHTML: { __html: html },
    })
  }

  shouldComponentUpdate(nextProps) {
    const { props, htmlEl } = this

    // We need not rerender if the change of props simply reflects the user's edits.
    // Rerendering in this case would make the cursor/caret jump

    // Rerender if there is no element yet... (somehow?)
    if (!htmlEl) {
      return true
    }

    // ...or if html really changed... (programmatically, not by user edit)
    if (nextProps.textual) {
      if (nextProps.html !== htmlEl.innerText && nextProps.html !== props.html) {
        return true
      }
    } else if (nextProps.html !== htmlEl.innerHTML && nextProps.html !== props.html) {
      return true
    }

    const optional = ['style', 'className', 'disable', 'tagName']

    // Handle additional properties
    return optional.some(name => props[name] !== nextProps[name])
  }

  componentDidUpdate() {
    if (this.htmlEl && this.props.html !== this.htmlEl.innerHTML) {
      // Perhaps React (whose VDOM gets outdated because we often prevent
      // rerendering) did not update the DOM. So we update it manually now.
      this.htmlEl.innerHTML = this.props.html
    }
  }

  onPaste = evt => {
    // evt.preventDefault()
    // const txt = evt.clipboardData.getData('text/plain')
    // console.log(evt)
    let content
    evt.preventDefault()
    if (evt.clipboardData) {
      content = (evt.originalEvent || evt).clipboardData.getData('text/plain')
      document.execCommand('insertText', false, content)
    } else if (window.clipboardData) {
      content = window.clipboardData.getData('Text')
      document.selection.createRange().pasteHTML(content)
    }
  }

  // Prevent enter keypress when textual mode is on
  onKeyPress = evt => {
    if (!this.props.textual) return
    if (evt.charCode == 13) {
      evt.preventDefault()
    }
  }

  onFocus = evt => {
    if (
      !this.props.textual ||
      !this.props.selectText ||
      !(
        (this.lastHtml && this.lastHtml === this.props.selectText) ||
        this.htmlEl.innerText === this.props.selectText
      )
    ) {
      return
    }
    setTimeout(() => {
      let sel
      let range
      if (window.getSelection && document.createRange) {
        range = document.createRange()
        range.selectNodeContents(this.htmlEl)
        sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
      } else if (document.body.createTextRange) {
        range = document.body.createTextRange()
        range.moveToElementText(this.htmlEl)
        range.select()
      }
    }, 1)
  }

  emitChange = evt => {
    if (!this.htmlEl) return
    const html = this.props.textual ? this.htmlEl.innerText : this.htmlEl.innerHTML
    if (this.props.onChange && html !== this.lastHtml) {
      this.props.onChange(evt, html)
    }
    this.lastHtml = html
  }
}



// WEBPACK FOOTER //
// ./ui/Input/Content.js